import React from "react";
import ClientField from "../misc/ClientField";
import { connect } from "react-redux";
import { Header, Grid, Modal, Button, Icon } from "semantic-ui-react";

class ClientPickModal extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = this.getInitialState();
    this.onChange = this.onChange.bind(this);
    this.saveAndExit = this.saveAndExit.bind(this);
  }

  getInitialState() {
    return {
      client: 0,
      clientName: "No Client Selected"
    };
  }

  onChange(e, data) {
    let clientName = "";

    if (typeof data.options !== "undefined" && data.options.length > 0) {
      data.options.map(function(item) {
        if (item.value === data.value) {
          clientName = item.text;
        }
      });

      this.setState({
        client: data.value,
        clientName
      });
    }
  }

  saveAndExit() {
    this.props.onSelectClient(this.state.client);
  }

  render() {
    let self = this;

    return (
      <Modal
        open={this.props.open}
        onClose={this.props.cancelSelect}
        closeIcon
        width={500}
      >
        <Header icon="briefcase" content="Choose Client" />
        <Modal.Content>
          <div>
            <Grid>
              <Grid.Column width={16}>
                <ClientField
                  selectedClient={this.state.client}
                  onChange={(e, data) => self.onChange(e, data)}
                  placeholder="Begin typing to select a client..."
                  anyInstance={true}
                  forceFocus={true}
                  disableAddNew
                />
              </Grid.Column>
            </Grid>
          </div>
        </Modal.Content>
        <Modal.Actions>
          <Button primary onClick={this.saveAndExit}>
            <Icon name="briefcase" /> Select Client
          </Button>
          <Button color="grey" onClick={this.props.cancelSelect}>
            <Icon name="dont" /> Cancel
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

function mapStateToProps(state) {
  return {
    username: state.main.username,
    userId: state.main.userId,
    userRole: state.main.userRole
  };
}

export default connect(mapStateToProps, null)(ClientPickModal);



// WEBPACK FOOTER //
// ./src/components/modals/ClientPickModal.js